import React from "react";
import { LOCATION_NOT_VERIFIED, checkInGateDetail, isCheckInUnverified } from "../utils/checkInGate";

// Small amber marker for an attendee who skipped the check-in location gate
// (GIS-271). Renders nothing for everyone else. `entry` is the attendee's
// eventUsers entry, or any object carrying its checkInUnverified /
// checkInGatePhase keys.
const LocationNotVerifiedBadge = ({ entry, className = "" }) => {
  if (!isCheckInUnverified(entry)) return null;
  const detail = checkInGateDetail(entry);
  return (
    <span
      title={detail}
      aria-label={`${LOCATION_NOT_VERIFIED}. ${detail}`}
      className={`inline-block rounded bg-amber-500 px-1 py-0.5 text-[10px] font-semibold leading-tight text-white ${className}`}
    >
      {LOCATION_NOT_VERIFIED}
    </span>
  );
};

export default LocationNotVerifiedBadge;
